import * as React from 'react';
import {createRoot} from '@wordpress/element';
import Builder from './view';

const init = () => {
    if (document.body.classList.contains('wp-admin')) return;
    document.querySelectorAll<HTMLElement>('[data-art-builder]').forEach(root => {
        if (root.dataset.initialized) return;
        const config = root.parentElement?.querySelector('script.art-builder-config')?.textContent;
        if (!config) return;
        try {
            createRoot(root).render(<Builder config={JSON.parse(config)}/>);
            root.dataset.initialized = 'true';
        } catch { root.textContent = 'The builder could not load. Please refresh the page.'; }
    });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
